<template>
  <div v-if="formData">
    <validation-observer v-slot="{ invalid }" ref="observer" tag="div">
      <overlay-progress-circular
        :value="submitting"
        color="#E3F2FD"
        :size="78"
        :width="6"
      />
      <form class="form-horizontal form-register" @submit.prevent="submit">
        <div class="base-fields">
          <!-- Tous les champs de base -->
          <cps-base-fields
            :formData="formData"
            :userData="registrationData.user"
            :isCps="isCps"
            :creationMode="creationMode"
          ></cps-base-fields>
        </div>
        <div class="identifier-fields">
          <!-- Tous les champs d'identification -->
          <cps-identifier-fields
            :formData="formData"
            :userData="registrationData.user"
            :registrationData="registrationData"
            :creationMode="creationMode"
          ></cps-identifier-fields>
        </div>
        <div class="connexion-fields">
          <!-- Tous les champs de connexion -->
          <cps-connexion-fields
            :formData="formData"
            :userData="registrationData.user"
          ></cps-connexion-fields>
        </div>
        <div class="additional-fields">
          <!-- Tous les champs additionnels -->
          <div
            class="cps-additionals-fields container"
            v-if="hasAdditionalFields()"
          >
            <h2 class="form-title">
              {{ $texts.additionalsFieldsTitle }}
            </h2>
            <input-field
              v-for="addField in additionalFields"
              :key="addField.id"
              :fieldId="'AdditionalField/' + addField.id"
              :name="addField.name"
              :description="addField.description"
              :tooltip="addField.tooltip"
              :required="addField.required"
              :enabled="addField.enabled"
              :pattern="addField.regexp"
              v-model="registrationData.user.additionalFields[addField.id]"
            ></input-field>
          </div>
        </div>
        <div class="attachment-fields" v-if="hasAttachmentFields()">
          <!-- Toutes les pièces jointes -->
          <h2 class="form-title">{{ $texts.attachmentsTitle }}</h2>
          <file-field
            v-for="attField in attachmentFields"
            :key="attField.id"
            :fieldId="'AttachmentField/' + attField.id"
            :name="attField.name"
            :description="attField.description"
            :tooltip="attField.tooltip"
            :required="attField.required"
            :enabled="attField.enabled"
            :pattern="attField.regexp"
            @change="updateAttachment(attField.id, $event)"
          ></file-field>
        </div>
        <checkbox-field
          v-if="
            formData.checkbox_ValidData && formData.checkbox_ValidData.visible
          "
          checkboxId="ValidData"
          :name="formData.checkbox_ValidData.name"
          :description="formData.checkbox_ValidData.description"
          :tooltip="formData.checkbox_ValidData.tooltip"
          :required="formData.checkbox_ValidData.required"
          :enabled="formData.checkbox_ValidData.enabled"
          type="checkbox"
          v-model="registrationData.user.validData"
        ></checkbox-field>
        <checkbox-field
          v-if="formData.checkbox_CGU && formData.checkbox_CGU.visible"
          checkboxId="CGU"
          :name="formData.checkbox_CGU.name"
          :description="formData.checkbox_CGU.description"
          :tooltip="formData.checkbox_CGU.tooltip"
          :required="formData.checkbox_CGU.required"
          :enabled="formData.checkbox_CGU.enabled"
          type="checkbox"
          v-model="registrationData.user.CGU"
        ></checkbox-field>
        <checkbox-field
          v-if="
            formData.checkbox_Newsletter && formData.checkbox_Newsletter.visible
          "
          checkboxId="Newsletter"
          :name="formData.checkbox_Newsletter.name"
          :description="formData.checkbox_Newsletter.description"
          :tooltip="formData.checkbox_Newsletter.tooltip"
          :required="formData.checkbox_Newsletter.required"
          :enabled="formData.checkbox_Newsletter.enabled"
          type="checkbox"
          v-model="registrationData.user.newsletter"
        ></checkbox-field>
        <div class="additional-checkboxes">
          <!-- Toutes les checkboxes additionnelles -->
          <checkbox-field
            v-for="addCheckbox in additionalCheckboxes"
            :key="addCheckbox.id"
            :checkboxId="'AdditionalCheckbox/' + addCheckbox.id"
            :name="addCheckbox.name"
            :description="addCheckbox.description"
            :tooltip="addCheckbox.tooltip"
            :required="addCheckbox.required"
            :enabled="addCheckbox.enabled"
            type="checkbox"
            v-model="registrationData.user.additionalCheckboxes[addCheckbox.id]"
          ></checkbox-field>
        </div>
        <div class="Captcha" style="  display: flex;  justify-content: center;">
          <PSCaptchaRecaptchaRoutingComponent
            ref="cpsIndividualCaptcha"
            v-model="registrationData.captchaSolution"
          ></PSCaptchaRecaptchaRoutingComponent>
        </div>

        <div class="alert alert-danger" v-if="submitError">
          {{ submitError }}
        </div>
        <div class="buttons">
          <a :href="$appSettings.CancelUrl">{{ $texts.cancelButton }}</a>
          <button
            :disabled="invalid || submitting"
            type="submit"
            class="btn btn-success"
          >
            {{ $texts.validateButton }}
          </button>
        </div>
      </form>
    </validation-observer>
    <div style="display:none">
      <form ref="checkboxForm" method="POST" :action="getTarget()">
        <!-- Checkbox ValidData -->
        <input
          class="flex"
          v-if="formData.checkbox_ValidData.isPost"
          :name="formData.checkbox_ValidData.name"
          :value="registrationData.user.validData"
        />
        <!-- Checkbox CGU -->
        <input
          class="flex"
          v-if="formData.checkbox_CGU.isPost"
          :name="formData.checkbox_CGU.name"
          :value="registrationData.user.CGU"
        />
        <!-- Checkbox Newsletter -->
        <input
          class="flex"
          v-if="formData.checkbox_Newsletter.isPost"
          :name="formData.checkbox_Newsletter.name"
          :value="registrationData.user.newsletter"
        />
        <!-- Additionals Checkboxes -->
        <div
          class="flex flex-row"
          v-for="addCheckbox in additionalCheckboxes"
          :key="addCheckbox.id"
        >
          <input
            v-if="addCheckbox.checkboxFormType.isPost"
            class="flex"
            :name="addCheckbox.checkboxFormType.labelPost"
            :value="getValueAdditionalCheckbox(addCheckbox.id)"
          />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { ValidationObserver } from "vee-validate";
import CpsBaseFields from "./CpsBaseFields.vue";
import CpsIdentifierFields from "./CpsIdentifierFields.vue";
import CpsConnexionFields from "./CpsConnexionFields.vue";
import CheckboxField from "../fields/CheckboxField.vue";
import InputField from "../fields/InputField.vue";
import FileField from "../fields/FileField.vue";
import OverlayProgressCircular from "@/Commons/components/OverlayProgressCircular.vue";
import { RegistrationService } from "@/InscriptionFlow/services/RegistrationService";
import { getWebApiErrorMessage } from "@/Commons/ErrorHelper";
import { RegistrationStatus } from "@/InscriptionFlow/models/enums/RegistrationStatus";
import { RegistrationSubMode } from "@/InscriptionFlow/models/enums/RegistrationSubMode";
import { InscriptionFlowFormType } from "@/InscriptionFlow/models/enums/InscriptionFlowFormType";
import PSCaptchaRecaptchaRoutingComponent from "../../../Captcha/components/PSCaptchaRoutingComponent";

export default Vue.extend({
  name: "cps-individual",

  components: {
    ValidationObserver,
    CpsBaseFields,
    CpsIdentifierFields,
    CpsConnexionFields,
    CheckboxField,
    InputField,
    FileField,
    OverlayProgressCircular,
    PSCaptchaRecaptchaRoutingComponent,
  },

  props: {
    formData: {
      type: Object,
    },
    registrationData: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      loadingError: null,
      submitError: null,
      submitting: false,
    };
  },

  computed: {
    additionalFields() {
      if (!this.formData) {
        return [];
      }
      return this.formData.additionalFields
        .filter((f) => f.visible)
        .sort((a, b) => a.order - b.order);
    },
    attachmentFields() {
      return this.formData.attachmentFields
        .filter((f) => f.visible)
        .filter((f) => f.attachmentFieldFormType.isActive)
        .sort((a, b) => a.order - b.order);
    },
    additionalCheckboxes() {
      return this.formData.additionalCheckboxes
        .filter((f) => f.visible)
        .filter((f) => f.checkboxFormType.isActive)
        .sort((a, b) => a.order - b.order);
    },

    isCps() {
      return this.registrationData.formType == InscriptionFlowFormType.Cps;
    },
    creationMode() {
      return (
        this.registrationData.registrationSubMode ==
          RegistrationSubMode.Creation ||
        this.registrationData.registrationSubMode ==
          RegistrationSubMode.CreationWithoutAssociation
      );
    },
  },

  methods: {
    async submit() {
      this.submitError = null;
      this.submitting = true;
      const isValid = await this.$refs.observer.validate();

      if (!isValid) {
        this.submitting = false;
        return;
      }

      RegistrationService.registration(
        this.$appSettings.Name,
        this.registrationData
      )
        .then((result) => {
          switch (result) {
            case RegistrationStatus.Success:
              this.$router.push({
                name: "inscription-flow-end",
                query: {
                  email: this.registrationData.user.email,
                },
              });
              break;

            case RegistrationStatus.SuccessAndConnected:
              if (
                this.$appSettings.AutomaticEmailValidation &&
                this.$appSettings.AutoValidateUser
              ) {
                if (this.$appSettings.MethodIsPost) {
                  this.$refs.checkboxForm.submit();
                } else {
                  window.location.href = this.getTarget();
                }
              } else {
                this.$router.push({
                  name: "inscription-flow-end",
                  query: {
                    email: this.registrationData.user.email,
                  },
                });
              }
              break;
          }
        })
        .catch((error) => {
          this.$refs["cpsIndividualCaptcha"].reset();
          switch (error.response.data) {
            case RegistrationStatus.InvalidPassword:
              this.submitError = this.$texts.invalidPasswordError;
              break;

            case RegistrationStatus.EmailAlreadyUsed:
              this.submitError = this.$texts.emailAlreadyUsedError;
              break;

            case RegistrationStatus.BlackListedEmail:
              this.submitError = this.$texts.emailBlackListedError;
              break;

            case RegistrationStatus.LoginAlreadyUsed:
              this.submitError = this.$texts.loginAlreadyUsedError;
              break;

            case RegistrationStatus.NationalIdAlreadyUsed:
              this.submitError = this.$texts.nationalIdAlreadyUsedError;
              break;

            case RegistrationStatus.NationalIdInvalid:
              this.submitError = this.$texts.nationalIdInvalidError;
              break;
            case RegistrationStatus.CaptchaSolutionError:
              this.submitError = this.$texts.captchaSolutionError;
              break;
            case RegistrationStatus.WrongLoginGenerated:
              this.submitError = this.$texts.wrongLoginGeneratedError;
              break;
            default:
              this.submitError = getWebApiErrorMessage(error);
              break;
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    },

    getTarget() {
      return `/AutoConnectSSO/Redirect?target=${this.$appSettings.TargetURL}`;
    },

    updateAttachment(id, value) {
      this.registrationData.user.attachmentFields[id] = value;
    },

    getValueAdditionalCheckbox(idCheckbox) {
      return (
        this.registrationData.user.additionalCheckboxes[idCheckbox] ?? false
      );
    },

    hasAdditionalFields() {
      return (
        this.formData &&
        this.formData.additionalFields &&
        this.formData.additionalFields.length != 0
      );
    },
    hasAttachmentFields() {
      const count = this.formData.attachmentFields
        .filter((f) => f.visible)
        .filter((f) => f.attachmentFieldFormType.isActive).length;
      return count != 0;
    },
  },

  watch: {
    formData: {
      deep: true,
      immediate: true,
      handler() {
        this.formData.additionalFields.forEach((element) => {
          this.$set(
            this.registrationData.user.additionalFields,
            element.id,
            ""
          );
        });

        this.formData.attachmentFields.forEach((element) => {
          if (element.attachmentFieldFormType == null) {
            element.attachmentFieldFormType = "";
          }
          this.$set(
            this.registrationData.user.attachmentFields,
            element.id,
            null
          );
        });

        this.formData.additionalCheckboxes.forEach((element) => {
          if (element.checkboxFormType == null) {
            element.checkboxFormType = "";
          }
          if (element.checkboxFormType.isActive) {
            this.$set(
              this.registrationData.user.additionalCheckboxes,
              element.id,
              false
            );
          } else {
            this.$set(
              this.registrationData.user.additionalCheckboxes,
              element.id,
              null
            );
          }
        });
      },
    },
  },
});
</script>

<style scoped>
.buttons {
  display: flex;
  justify-content: space-evenly;
}
.form-register {
  margin-bottom: 15px;
}
.form-title {
  font-size: 25px;
  color: #2fa1ba;
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>
